import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { patchTransactionRetry } from "../api";

export const useRetryTransaction = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();

  // Gunakan useMutation untuk meng-handle request PATCH
  const { mutate, isPending } = useMutation({
    mutationFn: patchTransactionRetry, // Fungsi API yang diimport
    onSuccess: () => {
      // Refetch data setelah transaksi berhasil dibatalkan
      queryClient.refetchQueries({ queryKey: ["TRANSACTION"] });

      // Arahkan ke halaman list transaksi
      router("/order-list");

      // Tampilkan toast sukses
      toast.success("Transaksi berhasil diretry!");
    },
    onError: (error: any) => {
      // Tangani jika ada error
      toast.error(`Gagal membatalkan transaksi: ${error.message}`);
    },
  });

  return { retryTransaction: mutate, isPending };
};
